import React, { useEffect, useState } from "react"
import { useDispatch, useSelector } from "react-redux";
import { getCurrentUser } from "../store/auth";
import { useNavigate } from "react-router-dom";
import { getAppTasks, getCandidateApps, loadAppRuningTasks, loadCandidateApps } from "../store/candidate";
import { getWorkflowTask, loadWorkflowTask, workflowTaskReceived } from "../store/WorkflowEngine";
import { setCurrentPageTitle, setCurrentRoute } from "../store/layoutUI";

const COMPLIANCE_STYLES = {
    card: {
        borderRadius: "22px",
        border: "1px solid rgba(226, 232, 240, 1)",
        background: "linear-gradient(180deg, #ffffff 0%, #fbfdff 100%)",
        boxShadow: "0 14px 34px rgba(15, 23, 42, 0.05)",
        overflow: "hidden"
    },
    cardHeader: {
        padding: "20px 22px 16px 22px",
        borderBottom: "1px solid rgba(226, 232, 240, 1)",
        background: "linear-gradient(180deg, #ffffff 0%, #f8fbff 100%)"
    },
    headerRow: {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        gap: "16px",
        flexWrap: "wrap"
    },
    headerCopy: {
        minWidth: "240px",
        flex: "1 1 420px"
    },
    headerActions: {
        display: "flex",
        alignItems: "center",
        justifyContent: "flex-end"
    },
    title: {
        fontSize: "18px",
        fontWeight: 800,
        color: "#0f172a",
        lineHeight: 1.25,
        margin: 0
    },
    titleRow: {
        display: "flex",
        alignItems: "flex-start",
        gap: "12px"
    },
    titleIcon: {
        width: "34px",
        height: "34px",
        borderRadius: "10px",
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        background: "#eff6ff",
        color: "#1d4ed8",
        fontSize: "15px",
        border: "1px solid rgba(191, 219, 254, 1)",
        flexShrink: 0
    },
    titleText: {
        display: "flex",
        flexDirection: "column",
        gap: "4px",
        minWidth: 0
    },
    subtitle: {
        fontSize: "13px",
        lineHeight: 1.5,
        color: "#64748b",
        margin: 0
    },
    cardBody: {
        padding: "18px 22px 22px 22px"
    },
    tableWrap: {
        border: "1px solid rgba(226, 232, 240, 1)",
        borderRadius: "18px",
        overflow: "auto",
        backgroundColor: "#ffffff"
    },
    table: {
        marginBottom: 0
    },
    tableHeadCell: {
        borderTop: "none",
        fontSize: "12px",
        fontWeight: 800,
        letterSpacing: "0.08em",
        textTransform: "uppercase",
        color: "#64748b",
        background: "#f8fafc",
        padding: "14px 16px"
    },
    cell: {
        verticalAlign: "middle",
        padding: "16px",
        borderTop: "1px solid rgba(226, 232, 240, 0.75)"
    },
    primaryAction: {
        display: "inline-flex",
        alignItems: "center",
        gap: "8px",
        borderRadius: "999px",
        border: "1px solid rgba(191, 219, 254, 1)",
        background: "#eff6ff",
        color: "#1d4ed8",
        padding: "7px 12px",
        fontSize: "12px",
        fontWeight: 700
    },
    secondaryAction: {
        display: "inline-flex",
        alignItems: "center",
        gap: "8px",
        borderRadius: "999px",
        border: "1px solid rgba(226, 232, 240, 1)",
        background: "#ffffff",
        color: "#334155",
        padding: "7px 12px",
        fontSize: "12px",
        fontWeight: 700
    },
    refreshButton: {
        display: "inline-flex",
        alignItems: "center",
        gap: "8px",
        borderRadius: "999px",
        border: "1px solid rgba(226, 232, 240, 1)",
        background: "#ffffff",
        color: "#334155",
        padding: "7px 12px",
        fontSize: "12px",
        fontWeight: 700
    },
    serialBadge: {
        minWidth: "30px",
        height: "30px",
        borderRadius: "999px",
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        background: "rgba(79, 70, 229, 0.08)",
        color: "#4338ca",
        fontSize: "12px",
        fontWeight: 800
    },
    formNameText: {
        fontSize: "14px",
        fontWeight: 700,
        color: "#0f172a"
    }
};

export default function Compliance() {

    const route = [
        { name: "Compliance Management", url: "" },
        { name: "Task List", url: "" },
    ];

    const [appTasklist, setAppTasklist] = useState([]);
    const [startBtnProccess, setStartBtnProccess] = useState(false);
    const [phaseName, setPhaseName] = useState("Compliance");
    const [selectedTaskId, setSelectedTaskId] = useState(0);

    const candidateAppsSelector = useSelector(getCandidateApps);
    const appTasksSelector = useSelector(getAppTasks);
    const workflowTaskSelector = useSelector(getWorkflowTask);


    const dispatch = useDispatch();
    const currentUser = getCurrentUser();
    const navigate = useNavigate();

    useEffect(() => {
        dispatch(setCurrentPageTitle("Compliance Management"));
        dispatch(setCurrentRoute(route));
    }, []);

    useEffect(() => {
        if (candidateAppsSelector.length > 0) {
            const mainWorkflow = candidateAppsSelector.filter(x => x.workflowType === 1);
            if (mainWorkflow.length > 0 && currentUser?.id > 0) {
                const wf = mainWorkflow[0]
                dispatch(loadAppRuningTasks(wf.oldWorkflowId, currentUser.id));
            }
        }
    }, [candidateAppsSelector]);

    useEffect(() => {
        if (appTasksSelector.length > 0) {
            const filterTasks = appTasksSelector.filter(x => x.taskType === 1 &&
                x.wiid > 0 &&
                x.wfPhase === phaseName);
            setAppTasklist(filterTasks);
        }
    }, [appTasksSelector])

    useEffect(() => {
        if (currentUser?.id > 0)
            dispatch(loadCandidateApps(currentUser.id))
    }, []);

    const handleCurrentTask = (wiid) => {
        setStartBtnProccess(true);
        setSelectedTaskId(wiid);
        dispatch(loadWorkflowTask(wiid));
    }

    useEffect(() => {
        if (workflowTaskSelector && startBtnProccess) {
            setStartBtnProccess(false);
            if (workflowTaskSelector.formType === "CF")
                navigate("/" + workflowTaskSelector.formName, { state: { workflowTask: workflowTaskSelector } });
            else
                navigate("/DynamicForm", { state: { workflowTask: workflowTaskSelector } });

            dispatch(workflowTaskReceived(""));
        }
    }, [workflowTaskSelector]);

    const handleRefresh = () => {
        if (currentUser?.id > 0) {
            dispatch(loadCandidateApps(currentUser.id));
        }
    }

    const usrType = localStorage.getItem("userType");

    return <React.Fragment>
        <div className="col-md-12 mt-2">
            <style>{`
                .compliance-table tbody tr:hover {
                    background-color: #fbfdff;
                }
            `}</style>
            <div className="card shadow-none border" style={COMPLIANCE_STYLES.card}>
                <div className="card-header" style={COMPLIANCE_STYLES.cardHeader}>
                    <div style={COMPLIANCE_STYLES.headerRow}>
                        <div style={COMPLIANCE_STYLES.headerCopy}>
                            <div style={COMPLIANCE_STYLES.titleRow}>
                                <span style={COMPLIANCE_STYLES.titleIcon}>
                                    <i className="fa fa-check-square-o" aria-hidden="true"></i>
                                </span>
                                <div style={COMPLIANCE_STYLES.titleText}>
                                    <div style={COMPLIANCE_STYLES.title}>
                                        Compliance Management
                                    </div>
                                    <p style={COMPLIANCE_STYLES.subtitle}>
                                        Review and acknowledge compliance-related forms and documents.
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div style={COMPLIANCE_STYLES.headerActions}>
                            <button
                                className="btn btn-sm"
                                style={COMPLIANCE_STYLES.refreshButton}
                                onClick={handleRefresh}
                            >
                                <i className="fa fa-refresh" aria-hidden="true"></i>
                                Refresh
                            </button>
                        </div>
                    </div>
                </div>
                <div className="card-body" style={COMPLIANCE_STYLES.cardBody}>
                    <div className="table-responsive" style={COMPLIANCE_STYLES.tableWrap}>
                        <table className="table align-items-center table-hover mb-0 compliance-table" style={COMPLIANCE_STYLES.table}>
                            <thead>
                                <tr>
                                    <th style={COMPLIANCE_STYLES.tableHeadCell}>#</th>
                                    <th style={COMPLIANCE_STYLES.tableHeadCell}>Form Name</th>
                                    <th style={COMPLIANCE_STYLES.tableHeadCell}>Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                {appTasklist.length > 0 ? appTasklist.map((item, key) => (
                                    <tr key={item.wiid || key}>
                                        <td style={COMPLIANCE_STYLES.cell}>
                                            <span style={COMPLIANCE_STYLES.serialBadge}>{key + 1}</span>
                                        </td>
                                        <td style={COMPLIANCE_STYLES.cell}>
                                            <div style={COMPLIANCE_STYLES.formNameText}>{item.taskName}</div>
                                        </td>
                                        <td style={COMPLIANCE_STYLES.cell}>
                                            <button
                                                onClick={() => handleCurrentTask(item.wiid)}
                                                disabled={true}
                                                title="Coming Soon"
                                                className="btn btn-sm"
                                                style={COMPLIANCE_STYLES.secondaryAction}
                                            >
                                                {startBtnProccess && selectedTaskId === item.wiid ? (
                                                    <i className="fa fa-spinner fa-spin mr-2"></i>
                                                ) : (
                                                    <i className="fa fa-eye mr-2" aria-hidden="true"></i>
                                                )}
                                                View / Acknowledgment
                                            </button>
                                        </td>
                                    </tr>
                                )) : (
                                    <tr>
                                        <td colSpan="3" style={COMPLIANCE_STYLES.cell} className="text-center text-muted">
                                            No compliance tasks found.
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    </React.Fragment>
}